export default "__VITE_ASSET__CGIwHhqL__"